<template>
  <div id="ravenwareSite" ref="ravenwareSite">

    <div id="site-header">
      <div class="row">
        <div class="col-md-3" id="site-logo-wrap">
          <a href="/"><img src="resources/images/logos/uk_business_broadband_x300.png" alt="UK Business Broadband Logo" id="site-logo"></a>
          <p id="associated">Part of <a href="https://ukitnetworks.com/" target="_blank"><img src="resources/images/logos/uk_it_networks_x100.png" alt="UK IT Networks" id="associated-logo"></a></p>
        </div>
        <div class="col-md-9 menu-items">
          <div class="items">
            <a href="/home">Business Broadband</a>
            <a href="/ethernet">Leased Line</a>
            <a href="/about-us">About Us</a>
            <a href="/support">Help and Support</a>
            <a href="/partners">Partners</a>
          </div>
          <a href="/support" class="btn btn-ukit-secondary">Contact Us</a>
        </div>
      </div>
    </div>

    <div id="background-outer" style="background-image:url('resources/images/ukit_networks_business_broadband.png');">
      <div id="background-inner">

        <div id="site-hero">
          <h1>About Us</h1>
          <h2>Working in association with <span>UK IT Networks</span><br>to provide high speed, reliable Business<br>Broadband to customers in the UK.</h2>
        </div>

        <div class="bg-white">
          <div id="carousel-wrap">
            <carousel :items="5" :margin="100" :loop="true" :nav="false" :autoplay="true" :autoplaySpeed="3000">
              <img src="resources/images/logos/grasslands.png" alt="Grasslands">
              <img src="resources/images/logos/orca.png" alt="Orca">
              <img src="resources/images/logos/ravenware.png" alt="Ravenware">
              <img src="resources/images/logos/energisave.png" alt="Energisave">
              <img src="resources/images/logos/jacksons.png" alt="Jacksons">
              <img src="resources/images/logos/baileys.png" alt="Baileys">
              <img src="resources/images/logos/beeston-shenton.png" alt="Beeston Shenton">
            </carousel>
          </div>

          <div class="info">
            <div class="row">
              <p>UK Business Broadband works in association with UK IT Networks which was founded as a customer-led business in 2012 with the support of key UK clients. We work with leading UK providers to deliver dedicated business-only internet access to hundreds of customers across the UK.</p>
              <div class="col-3">
                <img src="resources/images/ukit_networks_ram_clocktower.png">
                <span>Ram, Managing Director</span>
                <span>UK IT Networks</span>
              </div>
              <div class="col-9">
                <p><i>"Our strategy for supporting our customers is simple and clear - 'Assist our customers today, and they'll remember us tomorrow'. All teams across the business give that extra effort, taking ownership in delivering world-class support and provisioning new services at record speeds."</i></p>
              </div>
              <p>The team members at UK Business Broadband all work with the same ethos, our clients come first. We are focused on providing future-proof and resilient products to support business growth whilst providing honest, personable abd well-sipported customer service. Our success is supported by our glowing customer testimonials and customer retention, with <strong>over 90% of our customers continuing to stay with us</strong> and adapt their businesses with our services.</p>
            </div>
          </div>
        </div>

        <div class="bg-off-white">
          <div class="testimonials-wrap">
            <h6>What our customers think</h6>
            <div class="testimonials">
              <div class="testimonial">
                <div class="logo">
                  <img src="resources\images\logos\clogau.png">
                </div>
                <div class="quote">
                  <p>"First class from start to finish. I explained my requirements and was given a choice of speeds and services, along with the prices of each. All came through to sign off and installation dates were provided."</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="benefits-wrap">
          <div class="row">
            <div class="col-2">
              <img src="resources\images\icons\adapt\approachable_circle_x100.png">
              <h6>Approachable</h6>
            </div>
            <div class="col-2">
              <img src="resources\images\icons\adapt\dedicated_circle_x100.png">
              <h6>Dedicated</h6>
            </div>
            <div class="col-2">
              <img src="resources\images\icons\adapt\accountable_circle_x100.png">
              <h6>Accountable</h6>
            </div>
            <div class="col-2">
              <img src="resources\images\icons\adapt\professional_circle_x100.png">
              <h6>Professional</h6>
            </div>
            <div class="col-2">
              <img src="resources\images\icons\adapt\trustworthy_circle_x100.png">
              <h6>Trustworthy</h6>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div id="footer-top">
      <h6>Need some assistance? We can help.</h6>
      <v-btn href="/about-us">Find out more</v-btn>
    </div>

    <div id="footer-bottom">
      <div class="row">
        <div class="col-md-3">
          <img class="footer-logo" src="resources/images/logos/uk_business_broadband_x300.png" alt="UK Business Broadband Logo">
        </div>
        <div class="col-md-9">
          <ul class="footer-menu">
            <li><a href="https://ukitnetworks.com/privacy-policy/" target="_blank" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2479">Privacy Policy v1.0</a></li>
            <li><a href="/support" class="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-2542 current_page_item menu-item-2699">Customer Support</a></li>
            <li><a href="https://ukitnetworks.com/terms-and-conditions/" target="_blank" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2478">Terms and Conditions</a></li>
          </ul>
          <div class="legal-details">
            <p>Registered in England and Wales: 8026657</p>
            <p>Ofcom Reseller ID: FLV</p>
            <p>ICO Reg Number: A422750</p>
            <p>VAT Reg Number: 121 9534 29</p>
          </div>
        </div>
        <div class="col-md-12">
          <div class="social-icons">
            <a href="https://www.linkedin.com/company/uk-it-networks-limited">
              <i class="fa fa-linkedin-square"></i>
            </a>
            <a href="https://twitter.com/ukitnetworks?lang=en">
              <i class="fa fa-twitter-square"></i>
            </a>
            <a href="https://www.facebook.com/UKITNET/">
              <i class="fa fa-facebook-square"></i>
            </a>
          </div>
          <div class="contact-icons">
            <a href="tel:03443262154">
              <i class="fa fa-phone-square"></i>
            </a>
            <a href="mailto:info@ukbusinessbroadband.com" target="_blank">
              <i class="fa fa-envelope-square"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-loading-overlay/dist/vue-loading.css'
import _ from 'lodash'
import carousel from 'vue-owl-carousel'

export default {
  name: 'About Us',
  components: {
    carousel,
  },

  mounted() {
    this.mounted = true
    this.$nextTick(function() {
      this.iframeHeightChangeNotifyParent()
    })
    setTimeout(
      function() {
        this.iframeHeightChangeNotifyParent()
      }, 6000)
  },

  created() {
    window.addEventListener('resize', this.windowResized)
  },

  methods: {
    toggleLoading() {
      if (this.isLoading === true) {
        this.isLoading = false
      } else {
        this.isLoading = true
      }
    },

    windowResized: _.debounce(function(e) {
      let width = document.getElementById('ravenwareSite').scrollWidth
      if (width !== this.windowSize.width) {
        this.windowSize.width = document.getElementById('ravenwareSite').scrollWidth
        this.iframeHeightChangeNotifyParent()
      }
    }, 1),

    iframeHeightChangeNotifyParent: _.debounce(function(e) {
      let height
      let el = document.getElementById('ravenwareSite')
      if (el != null) {
        height = document.getElementById('ravenwareSite').scrollHeight
      } else {
        height = 200
      }
      window.parent.postMessage({ frameHeight: height }, '*')
    }, 1),

    iframeHeightSpecificSizeNotifyParent(height) {
      window.parent.postMessage({ frameHeight: height }, '*')
    },
  },

  data: () => ({
    windowSize: { width: 0 },
    isLoading: false,
    mounted: false,
    quoteFilter: { includeSOGEA: true, includeADSL: true, includeFTTC: true },
    quotes: null,
  }),
}
</script>
